import {ProductUI, type ProductUIProps} from '../ProductUI/ProductUI'
import {clsx} from 'clsx'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'
import {
  Product as WebGLProduct,
  type ProductProps as WebGLProductProps,
} from './../../../../../brand/components/Product/Product'

import Styles from './Product.module.css'

export type ProductProps = Omit<WebGLProductProps, 'children'> & {
  backgroundProps?: WebGLProductProps['backgroundProps']
  children: React.ReactNode
  productUI: Omit<ProductUIProps, 'children'>
  shouldAnimateIn?: boolean
  canAnimateIn?: boolean
  enterFrom?: 'bottom' | 'left' | 'right'
}

export const defaultProps: Partial<ProductProps> = {
  enterFrom: 'bottom',
}

export const Product = (props: ProductProps) => {
  const initializedProps: ProductProps = {...defaultProps, ...props}
  const {children, productUI, className, shouldAnimateIn, canAnimateIn, enterFrom, ...webGLProps} = initializedProps
  const prefersReducedMotion = usePrefersReducedMotion()
  const isAnimationEnabled = Boolean(shouldAnimateIn) && !prefersReducedMotion

  return (
    <div className={clsx(Styles['Product'], className)}>
      <WebGLProduct {...webGLProps}>
        <div
          className={Styles.Product__media}
          data-animate-in={isAnimationEnabled}
          data-can-animate-in={Boolean(canAnimateIn)}
          data-enter-from={enterFrom}
        >
          <ProductUI {...productUI}>{children}</ProductUI>
        </div>
      </WebGLProduct>
    </div>
  )
}
